import { Button } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './MoreUnreadNewsPill.module.scss';

export interface MoreUnreadNewsPillProps {
  onClick: () => void;
}

export const MoreUnreadNewsPill = ({ onClick }: MoreUnreadNewsPillProps) => {
  const { t } = useTranslation(['news']);

  return (
    <Button
      className={styles.moreUnreadNewsPillRoot}
      onClick={onClick}
      variant="tertiary"
      iconName="ArrowUp"
      label={t('news:moreUnreadNews')}
      data-testid="more-unread-news-pill"
    />
  );
};
